<template>
  <div class="verification_pg pg_frm_popup pg_signup">
    <div class="pg_bg_layer">

      <div class="row">
        <div class="col-xl-1 col-lg-1"></div>
        <div class="col-xl-10 col-lg-10 col-md-12 col-sm-12 login-user-section login_sec_box content_bx" @keydown.enter="login">

          <div class="modal-header">
            <div class="head_txt" v-if="!showInvalidUrl">Sign Up to Pragya for {{institutionObj.title}}</div>
            <div class="head_txt" v-if="showInvalidUrl">Error!</div>
          </div>

          <div class="modal-body">
            <template v-if="!showSuccessMessage">
              <template v-if="!showInvalidUrl">
                <div class="row">

                  <div class="col-xl-6">

                    <div class="row">
                      <div class="col-12 inst_logo">
                        <img :src="institutionObj.logoUrl" v-if="institutionObj.logoUrl" class="img-institution-signup">
                      </div>
                    </div>

                    <div class="row">
                      <div class="col-12 welcome_txt">
                        Welcome to Pragya Explore! This is your free resource for exploring programs, careers, salary information and regional employers.
                        Use it as much as you like, and be sure to apply to {{institutionObj.title}} when you are ready!
                      </div>
                    </div>

                  </div>

                  <div class="col-xl-6">
                    <div class="frm_flds_box">

                      <div class="row page_fld_section">
                          <div class="col-12 hd">
                              Get started with Explore by entering your information
                          </div>
                      </div>

                      <div class="row page_fld_section">
                        <div class="col-12">
                          <div class="fld-label" id="eMail">Email<sup>*</sup></div>
                        </div>
                        <div class="col-12">
                          <b-form-input type="email" v-model.email="eMail"  placeholder="Email" style="height: 1.5em !important;">
                          </b-form-input>
                        </div>
                      </div>

                      <div class="row page_fld_section">
                          <div class="col-12">
                              <div class="fld-label" id="password">First name <sup>*</sup></div>
                          </div>
                          <div class="col-12">
                                <b-form-input type="text" v-model.trim="firstName" placeholder="First Name" style="height: 1.5em !important;">
                                </b-form-input>
                          </div>
                      </div>

                      <div class="row page_fld_section">
                          <div class="col-12">
                              <div class="fld-label" id="password">Last name <sup>*</sup></div>
                          </div>
                          <div class="col-12">
                                <b-form-input type="text" v-model.trim="lastName" placeholder="Last Name" style="height: 1.5em !important;">
                                </b-form-input>
                          </div>
                      </div>


                      <div class="row page_fld_section">
                          <div class="col-12">
                              <div class="fld-label" id="password">Phone Number</div>
                          </div>
                          <div class="col-12">
                                <b-form-input type="text" v-model.trim="primaryPhoneNumber" placeholder="Phone Number (Optional)" style="height: 1.5em !important;">
                                </b-form-input>
                          </div>
                      </div>

                      <div class="row page_fld_section">
                        <div class="col-12 btn_container">
                          <b-button size="lg" @click="signUpUser" aria-label="verify">Sign Up</b-button>
                        </div>
                      </div>

                    </div>
                  </div>

                </div>
              </template>

              <template v-if="showInvalidUrl">
                <div class="row">
                  <div class="col-12 msg_sec">
                    <div class="msg_ic">
                      <span class="ic ic-error"></span>
                    </div>
                    <div class="msg_hd">
                      <h2>Invalid URL</h2>
                    </div>
                    <div class="msg_txt text-center">
                      Please check with your institution for correct URL.
                    </div>
                  </div>
                </div>
              </template>
            </template>

            <template v-if="showSuccessMessage">
              <div class="row">
                <div class="col-12 msg_sec">
                  <div class="msg_hd">
                    <h2>Sign up successful! </h2>
                  </div>
                  <div class="msg_txt">
                    A verification code and link were sent to your email. <br/>
                    Follow the instructions in the email to complete sign up and be sure to check the spam folder too.
                  </div>
                </div>
              </div>
            </template>

          </div> <!-- .modal-body -->

        </div>
        <div class="col-xl-1 col-lg-1"></div>
      </div>
      <div class="loading-spinner">
          <b-modal style="padding: 0px;" ref="loadingModal" ok-disabled cancel-diasbled hide-header hide-footer no-close-on-backdrop no-close-on-esc size="sm" centered>
              <div class="text-center" style="color: #FFF">
                  <i class="fa fa-spinner fa-3x fa-fw fa-pulse"></i>
              </div>
          </b-modal>
      </div>
    </div>
  </div>
</template>

<script>
  // import Vue from 'vue'
  import { mapActions, mapState } from 'vuex'

  export default {
    name: 'signup',
    components: {
    },
    data: () => {
      return {
        eMail: '',
        firstName: '',
        lastName: '',
        verificationCode: '',
        primaryPhoneNumber: '',
        campaignId: '',
        institutionOpenId: '',
        showSuccessMessage: false,
        institutionObj: {},
        showInvalidUrl: false
      }
    },

    watch: {

    },

    computed: {
      ...mapState({
      })
    },

    mounted () {
      this.loadVerificationPage()
    },

    methods: {
      ...mapActions([
        'loadLoginUser',
        'loadSignupUser',
        'setUserInfo',
        'loadLogDashboardActivity',
        'loadUpdateEmailCampaignClicks',
        'loadInstitutionMeta'
      ]),
      async loadVerificationPage () {
        this.campaignId = this.$route.query.campaignId
        this.institutionOpenId = this.$route.query.institutionId
        await this.loadUpdateEmailCampaignClicks({campaignId: this.campaignId, institutionOpenId: this.institutionOpenId})
        this.institutionObj = await this.loadInstitutionMeta(this.institutionOpenId)
        if (!this.institutionObj || this.institutionObj === null || this.institutionObj === '') {
          this.showInvalidUrl = true
        }
      },
      async signUpUser () {
        await this.$recaptchaLoaded()
        const token = await this.$recaptcha('login')
        console.log('captcha token: ', token)
        let userObj = {
          'eMail': this.eMail,
          'firstName': this.firstName,
          'lastName': this.lastName,
          'primaryPhoneNumber': this.primaryPhoneNumber
        }
        if (this.eMail.length < 1) {
          this.notifyFailure('Oops! Email is missing!')
        } else if (this.firstName.length < 1 || this.lastName.length < 1) {
          this.notifyFailure('Oops! First Name or Last Name is missing!')
        } else if (!this.campaignId || this.campaignId.length < 1 || !this.institutionOpenId || this.institutionOpenId.length < 1) {
          this.notifyFailure('Oops! URL is invalid! Please check the URL.')
        } else {
          this.showLoader()
          let response = await this.loadSignupUser({campaignId: this.campaignId, institutionOpenId: this.institutionOpenId, data: userObj})
          let status = response.status
          // let data = response.data
          if (status === 200) {
            this.showSuccessMessage = true
          } else {
            this.notifyFailure('Oops! Invalid url.')
          }
          this.hideLoader()
        }
      },
      showLoader () {
        if (this.$refs.loadingModal) {
          this.$refs.loadingModal.show()
        }
      },

      hideLoader () {
        if (this.$refs.loadingModal) {
          this.$refs.loadingModal.hide()
        }
      },

      notifyFailure (text) {
        this.$notify({
          group: 'notify',
          type: 'error',
          title: '',
          text: text
        })
      }
    }
  }
</script>

<style scoped>
.color-white a {
  color: #ffffff;
}
.close_button {
  margin-top: 10px;
}
.img-institution-signup {
  width: 400px!important;
}
</style>



// WEBPACK FOOTER //
// src/app/login/components/Signup.vue